﻿'use strict';

angular.module('ntmApp').factory('ForecastingBorrowResources', ['ForecastService', 'Utils', 'ForecastConfirmationService', 'FlashService',
    function (ForecastService, Utils, ForecastConfirmationService, FlashService) {

        function ForecastingBorrowResources(mode) {

            var self = this;
            var data = {};

            self.forecastMode = mode;

            self.load = function (header, selectedWeek, scenarioId, staffHeadersLoad, underAllocatedStaffLoad, reloadStaffHeaders) {

                var requestData = {
                    forecastView: header.forecastOptionsSummary.forecastView,
                    forecastScope: header.selectedForecastScope.id.trim(),
                    dateFrom: selectedWeek.startDate,
                    dateTo: selectedWeek.endDate,
                    forecastMode: self.forecastMode
                };

                if (scenarioId) {
                    requestData.scenarioBreadcrumb = scenarioId;
                }

                data = {
                    header: header,
                    selectedWeek: selectedWeek,
                    scenarioId: scenarioId,
                    staffHeadersLoad: staffHeadersLoad,
                    underAllocatedStaffLoad: underAllocatedStaffLoad,
                    requestData: requestData,
                    reloadBorrowerPane: self.load
                };

                self.loading = true;
                ForecastService.GetForecastBorrowResources(requestData).then(function (result) {

                    if (result.success) {
                        self.borrowerResourses = result.data.borrowResources;
                        self.loading = false;                  
                    }

                });

                if (reloadStaffHeaders && staffHeadersLoad) {
                    staffHeadersLoad(header, selectedWeek);
                    underAllocatedStaffLoad(header, selectedWeek, scenarioId);
                }
            };

            self.findStaff = function () {
                data.scope = self.selectedForecastScope;
                data.permissionToSchedules = self.permissionToSchedules;

                var popup = Utils.OpenModal('', 'src/staffForecasting/borrowerResources/templates/findStaffDialog.html', 'findStaffController', data, 'find-staff-dialog');

                popup.result.then(function () {               
                    popup.dismiss();
                });
            };

            self.undoBorrow = function (day, staff) {
                var msg = "Are you sure you want to undo the borrow of {0} from {1} on {2}".format(staff.fullName, day.facilityName, moment(day.date).format("dddd, MMMM DD YYYY"));

                var undoBorrowActionCallback = function () { sendUndoBorrowAction(day, staff); };

                ForecastConfirmationService.UndoBorrowAction(msg)
                                              .Yes(undoBorrowActionCallback)
                                              .Ask();
            };

            function sendUndoBorrowAction(day, staff) {

                var requestData = {
                    personId: staff.personId,
                    scenarioBreadcrumb: data.requestData.scenarioBreadcrumb,
                    dateDisplayed: day.date,
                    scenarioBorrowId: day.borrowId,
                    facilityCode: day.facilityId
                };

                self.loading = true;

                ForecastService.UndoBorrowStaff(requestData).then(function (result) {

                    if (result.success) {
                        self.load(data.header, data.selectedWeek, data.scenarioId, data.staffHeadersLoad, data.underAllocatedStaffLoad, true);
                        FlashService.Success("{0} successfully un-borrowed.".format(staff.fullName));
                    }
                    self.loading = false;
                });
            }


    }

    return (ForecastingBorrowResources);
}]);